import { gql } from '@apollo/client'

const SettingsFragment: any = gql`
  fragment SettingsData on Settings {
    id
    name
    handle
    config
    created_at
    updated_at
  }
`

const SettingsAttachmentFragment: any = gql`
    fragment SettingsAttachmentData on SettingsAttachment {
      id
      settings_id
      type
      file_type
      file_ext
      name
      url
    }
`

export const GET_SETTINGS: any = gql`
  query GetSettings {
    getSettings {
      ...SettingsData
    }
  }
  ${ SettingsFragment }
`

export const GET_SETTINGS_BY_ID: any = gql`
    query SettingsById($input: QuerySettingsByIdInput!) {
        settingsById(input: $input) {
          ...SettingsData
        }
    }
    ${ SettingsFragment }
`

export const GET_SETTINGS_BY_HANDLE: any = gql`
    query SettingsByHandle($input: QuerySettingsByHandleInput!) {
        settingsByHandle(input: $input) {
          ...SettingsData
        }
    }
    ${ SettingsFragment }
`

export const CREATE_SETTINGS: any = gql`
  mutation CreateSettings($input: MutationCreateSettingsInput!) {
    createSettings(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateSettingsSuccess {
        data {
          ...SettingsData
        }
      }
    }
  }
  ${ SettingsFragment }
`

export const UPDATE_SETTINGS: any = gql`
  mutation UpdateSettings($input: MutationUpdateSettingsInput!) {
    updateSettings(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateSettingsSuccess {
        data {
          ...SettingsData
        }
      }
    }
  }
  ${ SettingsFragment }
`

export const DELETE_SETTINGS: any = gql`
  mutation DeleteSettings($input: MutationDeleteSettingsInput!) {
    deleteSettings(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationDeleteSettingsSuccess {
        data
      }
    }
  }
`

export const CREATE_SETTINGS_ATTACHMENT: any = gql`
  mutation CreateSettingsAttachment($input: MutationCreateSettingsAttachmentInput!) {
    createSettingsAttachment(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateSettingsAttachmentSuccess {
        data {
          ...SettingsAttachmentData
        }
      }
    }
  }
  ${ SettingsAttachmentFragment }
`

export const GET_SETTINGS_ATTACHMENTS: any = gql`
  query SettingsAttachments($input: QuerySettingsAttachmentsInput!) {
    settingsAttachments(input: $input) {
      data {
        ...SettingsAttachmentData
      }
    }
  }
  ${ SettingsAttachmentFragment }
`

export const DELETE_SETTINGS_ATTACHMENT: any = gql`
    mutation DeleteSettingsAttachment($input: MutationDeleteSettingsAttachmentInput!) {
        deleteSettingsAttachment(input: $input) {
          __typename
          ... on FieldError {
            field
            message
          }
          ... on MutationDeleteSettingsAttachmentSuccess {
            data
          }
        }
    }
`

export const DELETE_SETTINGS_ATTACHMENT_BY_URL: any = gql`
    mutation DeleteSettingsAttachmentByUrl($input: MutationDeleteSettingsAttachmentByUrlInput!) {
        deleteSettingsAttachmentByUrl(input: $input) {
          __typename
          ... on FieldError {
            field
            message
          }
          ... on MutationDeleteSettingsAttachmentByUrlSuccess {
            data
          }
        }
    }
`
